export function funcFormatTime(dateTime) {
	const hours = dateTime.getHours()
	const min =
		dateTime.getMinutes() > 10
			? `${dateTime.getMinutes()}`
			: `0${dateTime.getMinutes()}`;
	const resultTime = hours + ":" + min;
	return resultTime;
}